import {Plan} from "../../../types";
import {getLidSpecsByPlan} from "../../../containers/domain/lidSpecs";

type ValidationResult = {
    ok: boolean;
    minHeight: number;
}

type MinHeightResult = {
    isApplicable: boolean;
    minHeight: number;
}

const getMinLidHeight = (plan: Plan): MinHeightResult => {
    const lidSpecs = getLidSpecsByPlan(plan);

    if (!lidSpecs) return {isApplicable: false, minHeight: 0};
    return { isApplicable: lidSpecs.minHeightMm > 0, minHeight: lidSpecs.minHeightMm / 10};
}

export const validateLidHeight = (plan: Plan): ValidationResult => {
    if (!plan.lid) return {ok: true, minHeight: 0}
    const {lid} = plan;
    const minHeightResult = getMinLidHeight(plan);

    if (!minHeightResult.isApplicable) return {ok: true, minHeight: 0}
    if (!lid.firmHeight) return {ok: true, minHeight: minHeightResult.minHeight}
    if (lid.firmHeight < minHeightResult.minHeight) return {ok: false, minHeight: minHeightResult.minHeight}
    return {ok: true, minHeight: minHeightResult.minHeight}
}